import { render, staticRenderFns } from "./VehicleForm.vue?vue&type=template&id=46d85999&scoped=true&"
import script from "./VehicleForm.vue?vue&type=script&lang=ts&"
export * from "./VehicleForm.vue?vue&type=script&lang=ts&"
import style0 from "./VehicleForm.vue?vue&type=style&index=0&id=46d85999&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d85999",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
